import axios from "axios";
import Swal from "sweetalert2";
import { getRoleById, loginUser } from "../../Service/UserService";
import { getLegalInfo } from "../../Service/LegalService";
import { isObjectEmpty } from "../../Utils/Utils";

const ACTION_LOGIN = 'ACTION_LOGIN';
const ACTION_LOGOUT = 'ACTION_LOGOUT';
const CLEAR_REFRESH_PATH = 'CLEAR_REFRESH_PATH';
const { $ } = window;

const logout = () => dispatch => {
  delete axios.defaults.headers.common['Authorization'];
  dispatch({ type: ACTION_LOGOUT });
}

const login = (payload, onError = err => { }) => dispatch => {
  loginUser(payload, async res => {
    const {
      access_token,
      refresh_token
    } = res.data;
    
    const [header, payload] = access_token.split('.');
    const userInfo = JSON.parse(atob(payload));
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);

    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    if (userInfo.role_id) {
      const response = await getRoleById(userInfo.role_id);
      const { privileges } = response.data;
      userInfo.privileges = privileges;
    }

    const legal_info = await getLegalInfo(); 
    if(legal_info.status == 200 && !isObjectEmpty(legal_info.data)) {
      userInfo.legal_name = legal_info.data.legal_name;
      userInfo.legal_code = legal_info.data.legal_code;
      userInfo.legal_affiliates = legal_info.data.legal_affiliates;
    }
    Swal.fire({
      icon: 'success',
      title: 'Succes!',
      text: 'Login succes, please wait for a while, system will be redirected to the home page',
      timer: 1500,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      }
    }).then(r => {
      $("#wrapper").css("display", "flex");
      dispatch({ type: ACTION_LOGIN, userInfo });
    })
  }, onError)

}

export { ACTION_LOGIN, ACTION_LOGOUT, CLEAR_REFRESH_PATH, login, logout };